<template>
    <div :id="carouselId || ''"
        class="carousel"
        :class="carouselClass || ''">
        <div class="carousel-inner">
            <slot :current="current"></slot>
        </div>
        <div class="carousel-nav-button carousel-nav-prev"
            aria-label="Anterior"
            @click="slide(false)">
        </div>
        <div class="carousel-nav-button carousel-nav-next"
            aria-label="Siguiente"
            @click="slide(true)">
        </div>
    </div>
</template>

<script>
export default {
	props: ["carousel-class", "carousel-id"],
	data() {
		return {
			current: 0
		};
	},
	computed: {
		size() {
			return this._vnode.children[0].children.length;
		}
	},
	methods: {
		slide(forward) {
			try {
				this.transitionName = forward ? "slide-next" : "slide-prev";
				let current = this.current;
				let next = forward
					? this.current < this.size - 1
						? this.current + 1
						: 0
					: this.current > 0
						? this.current - 1
						: this.size - 1;
				this.$emit("beforeChange", current, next);
				this.current = next;
				setTimeout(() => {
					this.$emit("afterChange", current, next);
				}, 501);
			} catch (e) {
				console.log("error slide", e);
			}
		}
	}
};
</script>
